<template>
  <div class="vip-benefits">
    <h2 class="benefits-title">
      <Icon name="material-symbols:workspace-premium" class="title-icon" />
      {{ $t('pay.vip.title') }}
    </h2>

    <div class="benefits-grid">
      <div v-for="benefit in benefits" :key="benefit.key" class="benefit-card">
        <div class="benefit-icon-wrapper">
          <Icon :name="benefit.icon" class="benefit-icon" />
        </div>
        <div class="benefit-content">
          <h3 class="benefit-title">{{ benefit.title }}</h3>
          <p class="benefit-description">{{ benefit.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const benefits = [
  {
    key: 'docTranslate',
    icon: 'material-symbols:description',
    title: t('pay.vip.benefits.doc.title'),
    description: t('pay.vip.benefits.doc.desc')
  },
  {
    key: 'imgTranslate',
    icon: 'material-symbols:image',
    title: t('pay.vip.benefits.img.title'),
    description: t('pay.vip.benefits.img.desc')
  },
  {
    key: 'noAd',
    icon: 'material-symbols:block',
    title: t('pay.vip.benefits.noAd.title'),
    description: t('pay.vip.benefits.noAd.desc')
  },
  {
    key: 'customerService',
    icon: 'material-symbols:support-agent',
    title: t('pay.vip.benefits.cs.title'),
    description: t('pay.vip.benefits.cs.desc')
  }
]
</script>

<style scoped lang="scss">
.vip-benefits {
  margin-bottom: 32px;
}

.benefits-title {
  font-size: 24px;
  font-weight: 700;
  color: #212529;
  margin: 0 0 24px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  .title-icon {
    font-size: 28px;
    color: #4A90E2;
  }
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.benefit-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 12px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;

  &:hover {
    border-color: #4A90E2;
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.1);
    transform: translateY(-2px);
  }
}

.benefit-icon-wrapper {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #4A90E2 0%, #50E3C2 100%);
  border-radius: 12px;

  .benefit-icon {
    font-size: 28px;
    color: white;
  }
}

.benefit-content {
  flex: 1;
}

.benefit-title {
  font-size: 16px;
  font-weight: 600;
  color: #212529;
  margin: 0 0 4px 0;
}

.benefit-description {
  font-size: 14px;
  color: #6C757D;
  margin: 0;
  line-height: 1.5;
}
</style>
